import type { InitCommandOptions } from '@cli-types/core-engine/commands.js'
import type { DatabaseProvider } from '@cli-types/next-adapter/init.js'

export function validateResolvedDatabaseProvider(
  provider: DatabaseProvider,
  options: InitCommandOptions
): void {
  if (options.databasePlan && provider !== 'vercel') {
    throw new Error('--database-plan can only be used with --database-provider vercel.')
  }
}
